<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>参展申请</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">参展申请</div>

        <Input
          search
          placeholder="请输入公司名称"
          v-model="companyName"
          @on-search="searchPro"
          style="width: 230px; margin-top: 20px"
        />
      </div>
      <div style="display: flex">
        <!-- <div class="header-tool-box" @click="editExApplyFile">
          <div class="htb-item">
            <span class="htb-add">+</span>
            <span>展商申请表下载</span>
          </div>
        </div> -->
        <div class="header-tool-box" v-if="false">
          <Upload
            :action="uploadUrl2"
            :show-upload-list="false"
            :default-file-list="defaultList1"
            :on-success="handleSuccess1"
            :format="['doc', 'docx']"
            :max-size="2048"
            :on-format-error="handleFormatError1"
            :on-exceeded-size="handleMaxSize1"
            :before-upload="handleBeforeUpload"
          >
            <div class="htb-item">
              <span class="htb-add">+</span>
              <span>上传/修改英文申请表</span>
            </div>
          </Upload>
        </div>
        <div class="header-tool-box" v-if="false">
          <Upload
            :action="uploadUrl2"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['doc', 'docx']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
          >
            <div class="htb-item">
              <span class="htb-add">+</span>
              <span>上传/修改申请表</span>
            </div>
          </Upload>
        </div>
        <!--        <div class="header-tool-box" @click="downExApply">-->
        <!--          <div class="htb-item">-->
        <!--            <span class="htb-add">+</span>-->
        <!--            <span>批量下载</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <Table :border="false" row-key="id" :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="companyName">{{
          row.companyName
        }}</template>
        <template slot-scope="{ row, index }" slot="isAgent">
          <template v-if="row.isAgent === '是'">
            组团：{{ row.agentName }}
          </template>
          <template v-if="row.isAgent === '否'"> 直销展位 </template>
          <template v-if="!row.isAgent"> 官网 </template>
        </template>
        <template slot-scope="{ row, index }" slot="inTime">{{
          row.inTime | moment("YYYY/MM/DD HH:mm:ss")
        }}</template>
        <!-- <template slot-scope="{ row, index }" slot="applyFileLink"><a :href="row.applyFileLink" download>{{row.applyFileLink}}</a></template> -->
        <template slot-scope="{ row, index }" slot="status">
          <template v-if="!row.needChange"> 已同步 </template>
          <template v-if="row.needChange"> 未同步 </template>
        </template>
        <template slot-scope="{ row, index }" slot="button">
          <Poptip
            confirm
            title="确定重新同步吗？"
            @on-ok="review(row)"
            :transfer="true"
          >
            <Button>重新同步</Button>
          </Poptip>
        </template>
        <template slot-scope="{ row, index }" slot="delete">
          <Poptip
            confirm
            title="确定删除吗？"
            @on-ok="deleteItem(row)"
            :transfer="true"
          >
            <Button>删除</Button>
          </Poptip>
        </template>
        <template slot-scope="{ row, index }" slot="down">
          <template>
            <a href="">下载</a>
          </template>
        </template>
      </Table>
      <div
        class="my-page"
        v-if="totalCount > pageSize"
        style="margin: 20px; text-align: center"
      >
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
let moment = require("moment");

export default {
  name: "host-ex-user",
  data() {
    return {
      columns: [
        {
          title: "公司名称",
          key: "companyName",
          slot: "companyName",
          align: "center",
        },
        {
          title: "报名方式",
          key: "isAgent",
          slot: "isAgent",
          align: "center",
        },
        {
          title: "报名时间",
          key: "inTime",
          slot: "inTime",
          align: "center",
        },
        // {
        //   title: "报名表下载链接",
        //   key: "applyFileLink",
        //   slot: "applyFileLink",
        //   align: "center"
        // },
        {
          title: "同步状态",
          key: "status",
          slot: "status",
          align: "center",
          width: 120,
        },
        // {
        //   title: "下载申请表",
        //   key: "down",
        //   slot: "down",
        //   align: "center",
        //   width: 120
        // },
        {
          title: " ",
          key: "button",
          slot: "button",
          width: 120,
        },
        {
          title: " ",
          key: "delete",
          slot: "delete",
          width: 100,
        },
      ],
      list: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      defaultList: [],
      defaultList1: [],
      fileId: "",
      companyName: "",
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      uploadUrl2: "getUploadUrl2",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getApplyList2: "hostCommonModule/getApplyList2",
      setChangeState: "hostCommonModule/setChangeState",
      delItem: "hostCommonModule/delItem",
      putApplyState: "hostCommonModule/putApplyState",
      getFile: "hostSetModule/getFile",
      getApplyConfig: "hostCommonModule/getApplyConfig",
      setApplyConfig: "hostCommonModule/setApplyConfig",
      getwordfile: "hostCommonModule/getwordfile",
    }),
    searchPro() {
      this.pageIndex = 1;
      this.init();
    },
    async init() {
      let list = await this.getApplyList2({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        companyName: this.companyName,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "ExhibitionId",
                  Value: "%" + this.exhibitionInfo.id + "%",
                },
              },
            ],
          },
        },
      });
      if (list && list.items.length > 0) {
        this.list = list.items;
      } else {
        this.list = [];
      }
      this.pageIndex = list.pageIndex;
      this.pageSize = list.pageSize;
      this.totalCount = list.totalCount;
      console.log(123,this.list);
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    async review(e) {
      let bool = await this.setChangeState(e.id);
      console.log(bool, "bool");
      if (bool && bool.successed) {
        this.$Message.success({
          content:
            "操作成功，数据同步需要时间，请稍后重新刷新页面获取最新状态！",
          duration: 5,
        });
      } else {
        this.$Message.success("操作失败，请重试！");
      }
      this.init();
    },
    // 删除
    async deleteItem(e) {
      let bool = await this.delItem(e.id);
      if (bool && bool.successed) {
        this.$Message.success({
          content: "删除成功！",
          duration: 5,
        });
      } else {
        this.$Message.success("删除失败，请重试！");
      }
      this.init();
    },
    //上传成功
    async handleSuccess(res, file) {
      console.log(res, "ressssss", file, "file");
      let data1 = await this.getApplyConfig();
      if (data1) {
        this.fileId = data1.id;
      }
      let opt = {
        Id: this.fileId,
        SetValues: {
          FileApplyTable: res.list[0],
          FileApplyTableName: file.name,
        },
      };
      let data = await this.setApplyConfig(opt);
      this.$Notice.success({
        title: "上传成功",
        desc: "文档已上传成功！",
      });
    },
    //英文上传成功
    async handleSuccess1(res, file) {
      let data1 = await this.getApplyConfig();
      if (data1) {
        this.fileId = data1.id;
      }
      let opt = {
        Id: this.fileId,
        SetValues: {
          FileApplyTableEn: res.list[0],
          FileApplyTableEnName: file.name,
        },
      };
      let data = await this.setApplyConfig(opt);
      this.$Notice.success({
        title: "上传成功",
        desc: "文档已上传成功！",
      });
    },
    //上传失败
    handleFormatError() {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传word格式的文件",
      });
    },
    //上传大小限制
    handleMaxSize() {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的文档",
      });
    },
    //上传失败
    handleFormatError1() {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传word格式的文件",
      });
    },
    //上传大小限制
    handleMaxSize1() {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的文档",
      });
    },
    //上传前钩子函数
    handleBeforeUpload() {},
    async editExApplyFile() {
      let data1 = await this.getApplyConfig();
      let fileType = data1.fileApplyTable.split("key=")[1];
      let data = await this.getwordfile(fileType);
    },
    async downExApply() {
      let key =
        "cloudExhibition/files/202009/d264a07469b543bc8415050a4df57a9a.doc";
      let key1 =
        "cloudExhibition/files/202009/2de1cdf72b064683bbf6e2c8565c3abd.doc";
      let key3 =
        "cloudExhibition/files/202009/b559c578c8ba406baf7d02d996c583c6.pdf";
      let data = await this.getFile(key3);
      console.log(data, "dataaaaaaaaaaaa");
    },
  },
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}
.layout-content {
  table {
  }
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;
  &:hover {
    color: #1890ff;
  }
}
.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;
  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;
    :hover {
      color: #333;
    }
    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>

